export const AuthPopupRetryReason = {
  timeout: "auth_popup_timeout",
  blocked: "auth_popup_blocked"
};

const TIMEOUT_FUZZ_MS = 1500;

function normalizeErrorString(value) {
  return String(value || "").toLowerCase();
}

function getPopupFromError(error) {
  return error?.popup || error?.originalError?.popup || null;
}

export function getAuthPopupRetryReason(error, timeoutSeconds = 300) {
  const errorCode = normalizeErrorString(error?.error || error?.code);
  const errorName = normalizeErrorString(error?.name);
  const errorMessage = normalizeErrorString(error?.message);
  const elapsedMs = Number(error?.elapsedMs);
  const timeoutMs = Number(timeoutSeconds) * 1000;
  const popup = getPopupFromError(error);

  if (
    errorCode === AuthPopupRetryReason.timeout ||
    errorCode === "timeout" ||
    errorCode.includes("timeout") ||
    errorName.includes("timeout") ||
    errorMessage.includes("timeout") ||
    errorMessage.includes("timed out") ||
    (Number.isFinite(elapsedMs) && elapsedMs >= timeoutMs - TIMEOUT_FUZZ_MS) ||
    (popup && popup.closed === false && Number.isFinite(elapsedMs) && elapsedMs > timeoutMs / 2)
  ) {
    return AuthPopupRetryReason.timeout;
  }

  if (
    errorCode === AuthPopupRetryReason.blocked ||
    errorCode === "popup_blocked" ||
    errorCode.includes("popup_blocked") ||
    errorName.includes("popupblocked") ||
    errorMessage.includes("popup blocked") ||
    errorMessage.includes("blocked the popup") ||
    errorMessage.includes("unable to open a popup") ||
    errorMessage.includes("unable to open popup")
  ) {
    return AuthPopupRetryReason.blocked;
  }

  return null;
}

export function closeAuthPopupFromError(error) {
  const popup = getPopupFromError(error);

  try {
    if (popup && typeof popup.close === "function") {
      popup.close();
    }
  } catch (_) {
    // Best-effort cleanup only.
  }
}
